import {
    Button,
    Dropdown,
    Form,
    Input,
    Modal,
    Menu,
    Space,
    Row,
    Popover,
    Flex,
} from 'antd';
import React, { useEffect, useRef, useState, CSSProperties } from 'react';
import './EditedHistoryDrawer.css';
import { DownOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { MdPictureAsPdf } from 'react-icons/md';
import { MdDocumentScanner } from 'react-icons/md';
import { MdEdit } from 'react-icons/md';
import { FaRegFileLines } from 'react-icons/fa6';
import { BsFileEarmarkX } from 'react-icons/bs';
import { AiOutlineFileExcel } from 'react-icons/ai';
import generatePDF, { Margin } from 'react-to-pdf';
import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';
import { CgAlignLeft, CgFileDocument } from 'react-icons/cg';
import { BsCodeSlash } from 'react-icons/bs';

import { useDispatch, useSelector } from 'react-redux';
import { run_Quick_Action_Update_output_name_ActionHandler } from '../../../../Redux/Actions/user/RunQuickActionOutputUpdateName';
import { quick_Action_Run_Status_ActionHandler } from '../../../../Redux/Actions/user/RunQuickActionStatus';
import {
    Run_QuickAction_Remove_Feedback_Success,
    run_Quick_Action_Update_output_feedback_ActionHandler,
} from '../../../../Redux/Actions/user/RunQuickActionOutputUpdateFeedback';
import 'draft-js/dist/Draft.css';
import EditHistoryDrawer from '../../RunQuickActionHistory/EditHistoryDrawer';
import { Save_Edit_Output_History_Action_Handler } from '../../../../Redux/Actions/user/SaveEditHistoryRunQa';
import { Restored_Output_EditHistory_Action_Handler } from '../../../../Redux/Actions/user/RestoredOutputEditHistoryRunQa';
import { Get_Output_History_list_Action_Handler } from '../../../../Redux/Actions/user/OutputListEditHistoryRunQa';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './BatchRunOutput.css';

const { TextArea } = Input;

const BatchRunOutput = ({
    data,
    QuickSaveExecuteResponse,
    back,
    setAccessLevel,
    params,
    setuplpad,
    setShowOutput,
    setBatchProcessing,
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [
        isModalVisibleForSaveEditHistory,
        setIsModalVisibleForSaveEditHistory,
    ] = useState(false);
    const [form] = Form.useForm();
    const [formForSaveEditHistory] = Form.useForm();
    const dispatch = useDispatch();
    const targetRef = useRef();
    const textareaRef = useRef(null);
    const [feedback, setFeedback] = useState('');
    const [isTextareaVisible, setTextareaVisible] = useState(false);
    const [isOptionsVisible, setOptionsVisible] = useState(true);
    const [error, setError] = useState('');
    const [RestoreData, setRestoreData] = useState('');

    const [isOutputEditorIsReadOnly, setIsOutputEditorIsReadOnly] =
        useState(true);

    const editorRef = useRef(null);
    const [isRestored, setIsRestored] = useState(false);
    let [editorContent, setEditorContent] = useState('');

    const [openEditHistory, setOpenEditHistory] = useState(false);

    let qaId = params?.id || params;

    const handleIsOutputEditorIsReadOnly = () => {
        setIsOutputEditorIsReadOnly(!isOutputEditorIsReadOnly);
    };

    const showEditHistoryDrawer = () => {
        setOpenEditHistory(true);
        setTimeout(() => {
            const parent = document.getElementsByClassName('ant-drawer-mask');
            for (let i = 0; i < parent?.length; i++) {
                parent[i].style.background = 'none';
            }
        }, 500);
    };

    const closeEditHistoryDrawer = () => {
        setOpenEditHistory(false);
    };

    useEffect(() => {
        let responsedData =
            QuickSaveExecuteResponse?.result?.response ||
            data?.result?.response ||
            '';

        if (
            responsedData != undefined &&
            responsedData != null &&
            !(responsedData.indexOf('<table') !== -1)
        ) {
            responsedData = responsedData.replace(/\n/g, '<br>');
        }
        setEditorContent(responsedData);
    }, [data]);

    const [isHtml, setisHtml] = useState(hasHtmlTags(editorContent));

    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        setEditorContent(data);
    };

    useEffect(() => {
        if (data) {
            let initialValue = {
                name: data.name,
            };
            form.setFieldsValue(initialValue);
            let aiResponse =
                QuickSaveExecuteResponse?.result?.response ||
                data?.result?.response;
            if (hasHtmlTags(aiResponse)) {
                handleHtmlHave();
            }
        }
    }, [data]);

    useEffect(() => {
        if (qaId && data?.action_run_id) {
            dispatch(
                Get_Output_History_list_Action_Handler(
                    qaId,
                    data?.action_run_id
                )
            );
        }
    }, [qaId, data?.action_run_id, isRestored]);

    const CallRestoreApi = (currentHistoryId, currentEditedHistory) => {
        dispatch(
            Restored_Output_EditHistory_Action_Handler(
                qaId,
                data?.action_run_id,
                currentHistoryId
            )
        );

        setIsRestored(!isRestored);

        currentEditedHistory = currentEditedHistory.replace(/\n/g, '<br>');
        setEditorContent(currentEditedHistory);
    };

    useEffect(() => {
        if (isTextareaVisible && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [isTextareaVisible]);

    useEffect(() => {
        return () => {
            dispatch(Run_QuickAction_Remove_Feedback_Success());
        };
    }, [dispatch]);

    const updateQuickAction_Name = useSelector(
        (state) =>
            state?.Run_quick_Action_Update_Output_Name_Data
                ?.quick_Action_Run_Updated_name
    );

    const updateQuickAction_Feedback = useSelector(
        (state) =>
            state?.Run_quick_Action_Update_Output_Feedback_Data
                ?.quick_Action_Run_Updated_feedback
    );

    useEffect(() => {
        if (updateQuickAction_Name?.message) {
            dispatch(
                quick_Action_Run_Status_ActionHandler(qaId, data?.action_run_id)
            );
        }
    }, [updateQuickAction_Name]);

    useEffect(() => {
        const editor = editorRef.current;
    }, [editorRef]);

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleCancelForSaveEditHistory = () => {
        setIsModalVisibleForSaveEditHistory(false);
    };

    const onFinish = (values) => {
        dispatch(
            run_Quick_Action_Update_output_name_ActionHandler(
                values,
                qaId,
                data?.action_run_id
            )
        );
        form.resetFields();
        setIsModalVisible(false);
    };

    const onFinishSaveEditHistory = (values) => {
        setIsModalVisibleForSaveEditHistory(false);
        let request = {
            edited_output: editorContent,
            ...values,
        };

        dispatch(
            Save_Edit_Output_History_Action_Handler(
                request,
                qaId,
                data?.action_run_id
            )
        );
        formForSaveEditHistory.resetFields();
        setEditorContent(editorContent);
        setIsOutputEditorIsReadOnly(!isOutputEditorIsReadOnly);
    };

    const onFinishFeedback = () => {
        const fback = { output_feedback: feedback };
        validateFeedback(feedback);
        if (feedback.length > 0) {
            dispatch(
                run_Quick_Action_Update_output_feedback_ActionHandler(
                    fback,
                    data?.action_run_id
                )
            );
            form.resetFields();
            setIsModalVisible(false);
        }
    };

    const downloadPdf = () => {
        targetRef.current.style.display = 'block';
        generatePDF(targetRef, {
            filename: (data?.name || 'QA RUN Output') + '.pdf',
            paperSize: 'A4',
            page: {
                // margin is in MM, default is Margin.NONE = 0
                margin: Margin.LARGE,
                // default is 'A4'
                format: 'letter',
            },
        });
        targetRef.current.style.display = 'none';
    };

    const downloadDoc = async () => {
        try {
            const filename = (data?.name || 'QA RUN Output') + '.docx';
            editorContent = editorContent.replace(
                /<td/g,
                "<td style='padding: 10px;border: 1px solid black !important;'"
            );
            editorContent = editorContent.replace(
                /<th>/g,
                "<th style='padding: 10px;border: 1px solid black !important;'>"
            );
            editorContent = editorContent.replace(
                '<table',
                "<table style='border-collapse: collapse !important;border-spacing: 0;'"
            );

            var converted = htmlDocx.asBlob(editorContent, {
                orientation: 'portrait',
                margins: { top: 720 },
            });
            saveAs(converted, filename);
        } catch (err) {
            console.error('Error generating DOCX:', err);
        }
    };

    const menu = (
        <Menu>
            <Menu.Item key='1'>Shorter</Menu.Item>
            <Menu.Item key='2'>Longer</Menu.Item>
            <Menu.Item key='2'>Simpler</Menu.Item>
            <Menu.Item key='2'>Professional</Menu.Item>
        </Menu>
    );

    const items = [
        {
            label: (
                <p className='download-option' onClick={downloadPdf}>
                    <MdPictureAsPdf />
                    Download in Pdf
                </p>
            ),
        },
        {
            type: 'divider',
        },
        {
            label: (
                <p className='download-option' onClick={downloadDoc}>
                    <MdDocumentScanner />
                    Download in Docs
                </p>
            ),
        },
    ];

    let formattedHtml = (
        <>
            <pre>
                <div
                    style={{ whiteSpace: 'pre-line', fontFamily: 'Poppins' }}
                    dangerouslySetInnerHTML={{ __html: editorContent }}></div>
            </pre>
        </>
    );

    const handleHtmlHave = () => {
        setisHtml(!isHtml);
    };

    const handleSendMessage = (event) => {
        setTextareaVisible(true);
        setFeedback(event.target.textContent);
        setOptionsVisible(false);
    };

    const validateFeedback = (value) => {
        if (value.length == 0) {
            setError('Feedback must be require');
        } else {
            setError('');
        }
    };

    const clearFeedback = () => {
        setFeedback('');
        setTextareaVisible(false);
        setOptionsVisible(true);
        setError('');
    };

    const handleInputFocus = () => {
        setTextareaVisible(true);
        setOptionsVisible(false);
    };

    const handleCopyToClipboard = async () => {
        try {
            targetRef.current.style.display = 'block';
            var editor = document.getElementById('response_output');

            var range = document.createRange();
            range.selectNodeContents(editor);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            document.execCommand('copy'); // change
            targetRef.current.style.display = 'none';
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Copied successfully!',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (err) {
            console.warn('Unable to copy to clipboard.', err);
        }
    };

    const handleCopyToClipboardHTML = async () => {
        try {
            await navigator.clipboard.writeText(
                QuickSaveExecuteResponse?.result?.response ||
                    data?.result?.response ||
                    'No text Available!'
            );

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Copied successfully!',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (err) {
            console.warn('Unable to copy to clipboard.', err);
        }
    };

    function hasHtmlTags(str) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = str;
        return tempElement.children.length > 0; // Check if there are child elements (tags)
    }

    const content = (
        <div>
            <h4 className='b-bottom'>Feedback</h4>
            {isOptionsVisible && (
                <div>
                    <p onClick={handleSendMessage} className='cursor'>
                        <FaRegFileLines />
                        Incorrect Output
                    </p>
                    <p onClick={handleSendMessage} className='cursor'>
                        <CgFileDocument />
                        Irrelevant Output
                    </p>
                    <p onClick={handleSendMessage} className='cursor'>
                        <AiOutlineFileExcel />
                        Incomplete Output
                    </p>
                    <p onClick={handleSendMessage} className='cursor'>
                        <BsFileEarmarkX />
                        Wrong Output format
                    </p>
                </div>
            )}
            {isTextareaVisible ? (
                <div className='p-relative'>
                    <Flex vertical gap={32}>
                        <TextArea
                            ref={textareaRef}
                            showCount
                            maxLength={250}
                            onChange={(e) => setFeedback(e.target.value)}
                            placeholder='Typing...'
                            value={feedback}
                            style={{
                                height: 120,
                                resize: 'none',
                                background: '#E9E9E9',
                            }}
                        />
                    </Flex>
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                    <Button
                        className='main-api feedback-btn'
                        disabled={!!error || feedback.trim().length === 0}
                        onClick={onFinishFeedback}>
                        Submit
                    </Button>
                </div>
            ) : (
                <input
                    type='text'
                    className='output-input chat-input'
                    placeholder='Click here to type...'
                    onFocus={handleInputFocus}
                    style={{ maxWidth: '125px' }}
                />
            )}
        </div>
    );

    return (
        <div className='mt-3'>
            <div className='chat-upper-batch-output '>
                <div className='buttons'>
                    <div
                        className='output-text-main'
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '7px',
                        }}>
                        <h5>Output</h5>
                        <div className='flex-batch justify-content-end '>
                            <button className='output-button'>
                                {data?.name}
                                <img
                                    src='/images/output.svg'
                                    className='output-img ms-2'
                                    alt=''
                                    onClick={() => setIsModalVisible(true)}
                                />
                            </button>
                            {isHtml ? (
                                <div className='downlod-div-batch dropdown-header'>
                                    <img
                                        src='/images/copy.svg'
                                        className='me-1'
                                        alt=''
                                    />
                                    <Dropdown
                                        overlay={
                                            <Menu>
                                                <Menu.Item>
                                                    <p
                                                        className='download-option'
                                                        onClick={
                                                            handleCopyToClipboard
                                                        }>
                                                        <CgAlignLeft className='download-option svg' />
                                                        Copy as Text
                                                    </p>
                                                </Menu.Item>
                                                <Menu.Item>
                                                    <p
                                                        className='download-option'
                                                        onClick={
                                                            handleCopyToClipboardHTML
                                                        }>
                                                        <BsCodeSlash className='download-option svg' />{' '}
                                                        Copy as HTML
                                                    </p>
                                                </Menu.Item>
                                            </Menu>
                                        }
                                        placement='bottomRight'
                                        arrow
                                        trigger={['click']}>
                                        <a onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                Copy <DownOutlined />
                                            </Space>
                                        </a>
                                    </Dropdown>
                                </div>
                            ) : (
                                <button
                                    className='msg-btn-2'
                                    onClick={handleCopyToClipboard}>
                                    <img
                                        src='/images/copy.svg'
                                        className='output-img svg'
                                    />
                                    &nbsp; Copy
                                </button>
                            )}
                            <div className='downlod-div-batch dropdown-header'>
                                <img
                                    src='/images/icon-dwnld.svg'
                                    className='me-1'
                                    alt=''
                                />

                                <Dropdown
                                    menu={{ items }}
                                    placement='bottomRight'
                                    arrow
                                    trigger={['click']}>
                                    <a onClick={(e) => e.preventDefault()}>
                                        <Space>
                                            Download <DownOutlined />
                                        </Space>
                                    </a>
                                </Dropdown>
                            </div>
                            <button
                                className='msg-btn'
                                onClick={() => {
                                    back(false);
                                    setAccessLevel('');
                                    setuplpad('');
                                    setShowOutput(false);
                                    setBatchProcessing('');
                                }}>
                                <img
                                    src='/images/refresh.svg'
                                    className='output-img'
                                    alt=''
                                />
                            </button>
                            <button
                                className='msg-btn'
                                style={{ fontSize: '18px', cursor: 'pointer' }}
                                onClick={handleIsOutputEditorIsReadOnly}>
                                <MdEdit />
                            </button>
                        </div>
                    </div>

                    <div className='message-section-height-data '>
                        <div style={{ height: '470px !important' }}>
                            <span ref={targetRef}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    ref={editorRef}
                                    onInit={(editor) => {
                                        console.log(
                                            'Editor initialized:',
                                            editor
                                        );
                                    }}
                                    data={editorContent}
                                    disabled={isOutputEditorIsReadOnly}
                                    config={{
                                        toolbar: [],
                                    }}
                                    onChange={handleEditorChange}
                                />
                            </span>
                        </div>

                        <span
                            ref={targetRef}
                            id='response_output'
                            style={{
                                padding: '10px',
                                position: 'relative',
                                fontFamily: 'Poppins',
                                display: 'none',
                            }}>
                            <div
                                className='hidden-table-css'
                                dangerouslySetInnerHTML={{
                                    __html: editorContent,
                                }}></div>
                        </span>
                    </div>

                    <div className='feeback-response-with-edit-history'>
                        <div className='m-auto' style={{ marginTop: '25px' }}>
                            <button
                                className='view_edit_history'
                                onClick={showEditHistoryDrawer}>
                                View Edit History
                            </button>

                            {isOutputEditorIsReadOnly ? (
                                <div></div>
                            ) : (
                                <button
                                    className='save_edit_history ml-3'
                                    onClick={() =>
                                        setIsModalVisibleForSaveEditHistory(
                                            true
                                        )
                                    }>
                                    Save
                                </button>
                            )}
                        </div>

                        {!updateQuickAction_Feedback && (
                            <Row
                                className='button-chat'
                                style={{ marginTop: '25px' }}>
                                <Popover
                                    content={content}
                                    title='Title'
                                    trigger='click'
                                    className='custom-popover'>
                                    <Button
                                        onClick={clearFeedback}
                                        // style={{
                                        //   float: "right",
                                        //   fontSize: "20px",
                                        //   marginTop: "1rem",
                                        // }}
                                    >
                                        <img src='/assets/receipt-edit.svg' />
                                    </Button>
                                </Popover>
                            </Row>
                        )}
                    </div>
                    {/* 
            <>
              {!updateQuickAction_Feedback && (
                <Row className="button-chat">
                  <Popover
                    content={content}
                    title="Title"
                    trigger="click"
                    className="custom-popover"
                  >
                    <Button
                      onClick={clearFeedback}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        marginTop: "1rem",
                      }}
                    >
                      <img src="/assets/receipt-edit.svg" />
                    </Button>
                  </Popover>
                </Row>
              )}
            </> */}
                </div>
            </div>

            <Modal
                title='Update QuickAction Name'
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                className='user-management-modal'>
                <Form
                    form={form}
                    onFinish={onFinish}
                    initialValues={{ name: data?.name }}>
                    <Form.Item
                        label='Enter Name'
                        name='name'
                        rules={[
                            {
                                required: true,
                                message: 'Please input the name!',
                            },
                        ]}>
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <button
                            type='submit'
                            className='model-btn-submit-management'>
                            Update
                        </button>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title='Save Edit History'
                visible={isModalVisibleForSaveEditHistory}
                onOk={() => form.submit()}
                onCancel={handleCancelForSaveEditHistory}
                className='user-management-modal'>
                <Form
                    form={formForSaveEditHistory}
                    onFinish={onFinishSaveEditHistory}
                    initialValues={{ title: '', description: '' }}>
                    <label>
                        Enter History Name{' '}
                        <span style={{ color: 'red' }}>*</span>{' '}
                    </label>
                    <Form.Item
                        name='title'
                        className='mt-2'
                        rules={[
                            {
                                required: true,
                                message: 'Please Enter History Name!',
                            },
                        ]}>
                        <Input placeholder='Enter history name' />
                    </Form.Item>
                    <label>Description</label>
                    <Form.Item
                        name='description'
                        rules={[
                            {
                                required: false,
                                message: 'Describe what you have changed',
                            },
                        ]}>
                        <TextArea
                            placeholder='Enter description here'
                            rows='5'
                        />
                    </Form.Item>
                    <Form.Item>
                        <button
                            type='submit'
                            className='model-btn-submit-management'>
                            Save
                        </button>
                    </Form.Item>
                </Form>
            </Modal>

            {openEditHistory && (
                <EditHistoryDrawer
                    setRestoreData={setRestoreData}
                    closeEditHistoryDrawer={closeEditHistoryDrawer}
                    openEditHistory={openEditHistory}
                    callRestoreApi={CallRestoreApi}
                    isRestored={isRestored}
                    QaID={qaId}
                    ActionId={data?.action_run_id}
                />
            )}
        </div>
    );
};

export default BatchRunOutput;
